export const  NOTIFICATION_ACTIONS = [
    {
        key: 'Go to questionnaire',
        value: '/question_disclaimer'
    },
    {
        key: 'Go to results',
        value: '/results'
    },
    {
        key: 'Go to book consult',
        value: '/book-consult'
    },
    {
        key: 'Go to spouse questionnaire',
        value: '/questionnaire_dashboard'
    },
    {
        key: 'Go to book consult: PUBLICIS2024',
        value: 'https://bright.as.me/publicis',
    }
];